import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Illustration} from 'shells/illustrations/illustration';
import {ImageWrapper} from 'shells/onboarding-modal/image-wrapper';
import {OnboardingModal} from 'shells/onboarding-modal/onboarding-modal';

import {OpenableModals, useOpenableModal} from '../../../openable-modals';

import {AddChatbot} from './pages/add-chatbot';
import {CustomizeChatbot} from './pages/customize-chatbot';
import {Goals} from './pages/goals';
import {OneClickTraining} from './pages/one-click-training';

export function ChatbotLearnMoreModal() {
    const {isOpen, onClose} = useOpenableModal(OpenableModals.CHATBOT_LEARN_MORE_MODAL);

    const pages = [
        {
            id: 'add-chatbot',
            body: <AddChatbot />,
            art: {
                background: colors.blueXlt,
                image: () => (
                    <div className='add-chatbot-illustration'>
                        <Illustration src='chatbot-onboarding/add-chatbot' width={300} />
                    </div>
                ),
            },
        },
        {
            id: 'one-click-training',
            body: <OneClickTraining />,
            art: {
                background: colors.blueXlt,
                image: () => (
                    <ImageWrapper
                        image={<Illustration src='chatbot-onboarding/one-click-training' />}
                        width={220}
                    />
                ),
            },
        },
        {
            id: 'goals',
            body: <Goals />,
            art: {
                background: colors.blueXlt,
                image: () => (
                    <ImageWrapper
                        image={<Illustration src='chatbot-onboarding/goals' />}
                        width={220}
                    />
                ),
            },
        },
        {
            id: 'customize-chatbot',
            body: <CustomizeChatbot />,
            art: {
                background: colors.blueXlt,
                image: () => (
                    <ImageWrapper
                        image={<Illustration src='chatbot-onboarding/customize-chatbot' />}
                        width={220}
                    />
                ),
            },
        },
    ];

    return (
        isOpen && (
            <OnboardingModal
                trapFocus={false}
                lastButtonText='Done'
                pages={pages}
                onClose={onClose}
                onFinish={onClose}
                canClickOutsideToClose={false}
            />
        )
    );
}
